import React from "react";
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { Circles } from '../common/loadingComponent';
import { writeErr } from '../common/logger';
import { isIE, isEdge } from '../common/utils';
import { alertsActions } from '../../store/alertsStore';
import { domainActions } from '../../store/domainStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiPost, getHostApi } from '../../store/apiWrapper';
import Paging from '../common/pagingComponent';
import Section from '../common/section';
import Message from '../common/message';
import BbCheckbox from '../styling/bbCheckbox';
import NoDataComponent from '../common/noDataComponent';
import ResponsiveTable from '../layoutItems/responsiveTable';
import ExcelExportButton from '../common/excelExportButton';
import CsvExportButton from '../common/csvExportButton';
import { popupActions } from '../../store/popupStore';
import { hasPermission } from '../../store/apiWrapper';
import AlertNotePreview from "./alertNotePreview";

class Alerts extends React.Component {
    initialOrderState = {
        portfolio: undefined,
        subjectObject: undefined,
        type: undefined,
        notified: undefined,
        seen: undefined
    };

    state = {
        portfolios: [],
        loading: false,
        selectAll: false,
        order: { ...this.initialOrderState }
    };

    render() {
        return (
            <>
                {this.props.alerts.error && this.props.alerts.error.exception && <Message type="error" options={{ renderInnerHtml: true}}
                    message={this.props.translate(this.props.alerts.error.exception, this.props.alerts.error.exceptionData)}
                />}
                {!this.state.loading && this.state.portfolios.length > 0 && <>
                    {this.renderPortfolios()}
                    <div className="card">
                        <div className="card-body">
                            {this.renderAlerts()}
                        </div>
                    </div>
                </>}
                {this.state.loading && <Circles />}
                {!this.state.loading && this.state.portfolios.length === 0 && <NoDataComponent />}
            </>
        );
    }

    componentDidMount() {
        this.setState({ loading: true, order: { notified: true} });
        this.getPortfolios();
    }

    componentDidUpdate(prevProps, _) {
        if (prevProps.activeLanguage && prevProps.activeLanguage.code !== this.props.activeLanguage.code) {
            this.setState({ loading: true });
            this.getPortfolios();
        }
    }

    renderPortfolios() {
        return (
            <Section className="alert-portfolios card" isSection={true} removeDataLevel={true} bodyStyle={{ border: "none", padding: "0 3em 3em 3em" }}
                style={{ borderRadius: '10px', border: "none", marginTop: '1em' }}
                headerStyle={{ marginLeft: "0", borderRadius: '10px', border: "none", cursor: "default" }} isOpen={true} fontAwesomeIconName="search-dollar"
                name={this.props.translate("Alerts.Portfolios")}
            >
                <div className="columns is-centered" style={{ flexDirection: "column", margin: 0 }}>
                    <table style={{ fontSize: "0.8em" }}
                        className={classnames('table table-report-section subjects-table with-ellipsed-column', { 'blurred': this.state.subjectsLoading })}
                    >
                        <thead>
                            <tr>
                                <th><BbCheckbox id={`all`} value={this.isAllChecked()} onChange={() => this.selectAll()} /></th>
                                <th><Translate id="Monitoring.Overview.Name" /></th>
                                <th><Translate id="Monitoring.Overview.Type" /></th>
                                <th className='align-right rpad'><Translate id="Monitoring.Overview.DailyCount" /></th>
                                <th className='align-right rpad'><Translate id="Monitoring.Overview.SubjectCount" /></th>
                                <th><Translate id="Monitoring.Overview.Monitoring" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.portfolios.map(p => this.renderPortfolioLine(p))}
                        </tbody>
                    </table>
            </div>
            </Section>
        );
    }

    renderPortfolioLine = (p) => {
        let ieFix = (isIE() || isEdge())
        return (
            <tr key={p.id}>
                <td>
                    <BbCheckbox
                        id={`${p.id}`}
                        disabled={p.alertsCount === 0}
                        value={this.props.alerts.filter.portfolios.includes(p.id)}
                        onChange={e => this.onChangeCheckBox(e, p.id)}>
                    </BbCheckbox>
                </td>
                <td>
                    <div key={p.id} className={`port-item ${p.alertsCount === 0 ? "disable" : ""} ${ieFix ? "isIE-Fix" : ""}`} >
                        {p.name != null && <div>{p.name.replace("<br />", " - ")}</div>}
                        {p.unreadCount > 0 && <div className="notification">{p.unreadCount}</div>}
                    </div> 
                </td>
                <td data-label={this.props.translate("Monitoring.Overview.Type")}>
                    <span>{ReactHtmlParser(p.type.replace("<br />", " - "))}</span>
                    <sup>{p.marketingCountry}</sup>
                </td>
                <td className='align-right rpad'
                    data-label={this.props.translate("Monitoring.Overview.DailyCount")}
                >
                    <span>
                        {p.dailyCount}
                    </span>
                </td>
                <td className='align-right rpad'
                    data-label={this.props.translate("Monitoring.Overview.SubjectCount")}
                >
                    <span>
                        {p.subjects}
                    </span>
                </td>
                <td data-label={this.props.translate("Monitoring.Overview.Monitoring")}>
                    <span>
                        {p.IsMonitored ?
                            <Translate id="Monitoring.Overview.Active" /> :
                            <Translate id="Monitoring.Overview.Inactive" />
                        }
                    </span>
                </td>
            </tr>
        )
    }

    showArrow = (state) => {
        if (state === false)
            return <FontAwesomeIcon icon="arrow-up" className='search-result-icon svg-standard-fill' />;
        else if (state === true)
            return <FontAwesomeIcon icon="arrow-down" className='search-result-icon svg-standard-fill' />;
        else
            return null;
    }

    renderAlerts() {
        return (
            <ResponsiveTable>
                <table className={`alerts-table table table-report-section fixed ${this.props.alerts.isLoading && !isNullOrUndefined(this.props.alerts.data) &&
                    this.props.alerts.data.alerts.length > 0 ? "blurred" : ""}`}
                >
                    <thead>
                        <tr>
                            <th className="with-pointer" style={{ width: "15%" }} onClick={() => this.orderBy("Portfolio", "portfolio")}>
                                <><Translate id="Alerts.Portfolio" /> {this.showArrow(this.state.order.portfolio)}</>
                            </th>
                            <th className="with-pointer" style={{ width: "20%" }} onClick={() => this.orderBy("SubjectObject", "subjectObject")}>
                                <><Translate id="Alerts.SubjectObject" /> {this.showArrow(this.state.order.subjectObject)}</>
                            </th>
                            <th className="with-pointer" style={{ width: "20%" }} onClick={() => this.orderBy("Type", "type")}>
                                <><Translate id="Report.Alerts.Type" /> {this.showArrow(this.state.order.type)}</>
                            </th>
                            <th style={{ width: "22%" }}>
                                <Translate id="Alerts.Description" />
                            </th>
                            <th className="with-pointer wide-nowrap" style={{ width: "17%"}} onClick={() => this.orderBy("Notified", "notified")}>
                                <><Translate id="Alerts.Created.Notified.Date" /> {this.showArrow(this.state.order.notified)}</>
                            </th>
                            {hasPermission(null, 'NotesInAlerts') && <th style={{ width: "3%" }}>
                            </th>}
                            <th className="with-pointer" style={{ width: "3%" }} onClick={() => this.orderBy("Seen", "seen")}>
                                {this.showArrow(this.state.order.seen)}
                            </th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.alerts.isLoading && (isNullOrUndefined(this.props.alerts.data) || this.props.alerts.data.alerts.length === 0) && <tr>
                            <td colSpan="6"><Circles /></td>
                        </tr>}
                        {!isNullOrUndefined(this.props.alerts.data) && this.props.alerts.data.alerts.map((a, i) => <tr
                            className={classnames("alert-row", { "seen": a.seen })} key={i}
                        >
                            <td data-label={this.props.translate("Alerts.Portfolio")}>{a.portfolio}{`${isNullOrUndefined(a.childType) ? "" : " - "}`}{a.childType}</td>
                            <td data-label={this.props.translate("Alerts.SubjectObject")}>{a.subjectObject}</td>
                            <td data-label={this.props.translate("Report.Alerts.Type")}>{a.event}</td>
                            <td data-label={this.props.translate("Alerts.Description")}>{this.eventDescription(a)}</td>
                            <td data-label={this.props.translate("Alerts.Created.Notified.Date")}>{a.notifiedFormated} / {a.createdFormated}</td>
                            {hasPermission(null, 'NotesInAlerts') && <td  style={{ verticalAlign: 'middle' }}>
                                {((this.isReader(a.portfolioId) && a.noteId) || (!this.isReader(a.portfolioId))) && 
                                    this.renderPencil(a.noteId, a.alertId, a.portfolioId)
                                }
                            </td>}
                            <td data-label={this.props.translate("Alerts.NewValue")} style={{ verticalAlign: 'middle' }}>
                                <div className={classnames("alerts-seen-value", { "seen": a.seen })} onClick={() => this.setSeen(a.portfolioId, a.alertId, a.seen)}></div>
                            </td>
                           
                        </tr>)}
                    </tbody>
                </table>
                {!isNullOrUndefined(this.props.alerts.data) && <div className={`table-action-wrapper ${this.props.alerts.isLoading ? "blurred" : ""}`}>
                    <div style={{ alignSelf: "center", margin: "1em 1em 1em 0" }}>
                        <ExcelExportButton onClick={() => this.exportAlerts()} disabled={this.props.alerts.data.total > this.props.alerts.data.exportMax} />
                    </div>
                    <div style={{ alignSelf: "center" }}>
                        <CsvExportButton style={{ margin: "1em 0" }} onClick={() => this.exportAlertsCsv()} />
                    </div>
                    <div className="paging-wrapper">
                        <Paging selectedPage={(this.props.alerts.filter.offset / this.props.alerts.filter.count) + 1}
                            totalPages={Math.ceil(this.props.alerts.data.total / this.props.alerts.filter.count)}
                            setPage={this.onPageClick} />
                    </div>
                    <div className="delete-wrapper">
                        <a className={classnames('link-functional', { 'is-disabled': (this.props.alerts.isLoading || this.props.alerts.data.unseen === 0) })}
                            onClick={() => this.selectAllSeen((this.props.alerts.data.alerts.filter(a => a.seen === false).length === 0 &&
                                this.props.alerts.data.unseen !== 0)  ? true : false)}
                        >
                            {(this.props.alerts.data.alerts.filter(a => a.seen === false).length === 0 && this.props.alerts.data.unseen !== 0)
                                ? <Translate id='Alerts.Dismiss.All' data={{count: this.props.alerts.data.unseen}} /> : <Translate id='Common.Dismiss' />}
                        </a>
                    </div>
                </div>}
            </ResponsiveTable>
        )
    }

    renderPencil(noteId, alertId, portfolioId){
        if (noteId) 
            return <AlertNotePreview noteId={noteId} targetId={`note-${noteId}`}>
                        <div id={`note-${noteId}`}><FontAwesomeIcon icon="pencil-alt" onClick={() => this.notesController(noteId, alertId, portfolioId)} className={classnames('search-result-icon svg-standard-fill', {'link-internal': noteId})} style={{color: "lightgray", cursor:"pointer"}}/></div>
                    </AlertNotePreview>
        return <div><FontAwesomeIcon icon="pencil-alt" onClick={() => this.notesController(null, alertId, portfolioId)} className={classnames('search-result-icon svg-standard-fill', {'link-internal': noteId})} style={{color: "lightgray", cursor:"pointer"}}/></div>
    }

    getPortfolios(){
        apiPost(`${window.babylonApiUrl}/api/portfolio/alerts/list`, null, null,
            (s) => {
                if (s.data.isSuccess)
                    this.onSuccess(s.data);
                else
                    this.onError({ exception: s.data.exception, exceptionData: s.data.exceptionData });
            },
            (e) => {
                writeErr(e);
                this.onError()
            }
        );
    }

    isReader(portfolioId){
        var port = this.state.portfolios.find(p => p.id == portfolioId);
        return !port.userRole ? false : port.userRole == 3;
    }
    notesController(noteId, alertId, portfolioId){
        this.props.showPopup("alertsNotesPopup", {
            open: true,
            close: () => this.props.hidePopup(),
            portfolioId: portfolioId,
            alertId: alertId,
            noteId: noteId,
            isReader: this.isReader(portfolioId),
            editNotes: (porfolioId, alertId, data) => this.editNotes(porfolioId, alertId, data)
        });
    }

    onSuccess(data) {
        if (!data.isSuccess) {
            this.setState({ loading: false, loadingAlerts: false });
            return;
        }
        if (data.items.length === 0) {
            this.setState({ loading: false });
            return;
        }
        let id = this.props.match.params.id;
        if (!isNullOrUndefined(id)) {
            if (data.items.filter((d) => { return d.id == id }).length > 0)
                this.setPortfolios([parseInt(id)]);
            else
                this.setPortfolios([]);
        }
        this.setState({ portfolios: data.items, loading: false });
    }

    onError(error = null) {
        this.setState({ loading: false, loadingAlerts: false });
        this.props.setAlertsError(isNullOrUndefined(error) ? { exception: "Common.Error" } : error);
    }

    getAlertList() {
        if(!this.props.alerts.isLoading)
            this.props.getAlerts();
    }

    exportAlerts() {
        if (!this.props.alerts.isLoading) {
            if (this.props.alerts.data.total > this.props.alerts.data.exportMax)
                this.props.showPopup('alertsExportLimitPopup', {
                    open: true,
                    close: () => this.props.hidePopup(),
                    title: this.props.translate("Common.ExportToExcel"),
                    exportMax: this.props.alerts.data.exportMax,
                    helpdesk: this.props.alerts.data.helpdesk
                });
            else
                this.props.exportAlerts();
        }
    }

    exportAlertsCsv() {
        if (!this.props.alerts.isLoading) {
            if (this.props.alerts.data.total > (this.props.alerts.data.exportMaxCsv || 500000))
                this.props.showPopup('alertsExportLimitPopup', {
                    open: true,
                    close: () => this.props.hidePopup(),
                    title: this.props.translate("Common.ExportToCsv"),
                    exportMax: this.props.alerts.data.exportMaxCsv,
                    helpdesk: this.props.alerts.data.helpdesk
                });
            else
                this.props.exportAlertsCsv();
        }
    }

    onChangeCheckBox(e, id) {
        var selected = [];
        if (e) {
            selected = this.props.alerts.filter.portfolios.concat(id);
            this.setState({ selectAll: selected.length === this.state.portfolios.length }, () => { this.setPortfolios(selected); });
        }
        else {
            selected = this.props.alerts.filter.portfolios.filter(item => item !== id)
            this.setState({ selectAll: false }, () => { this.setPortfolios(selected); });
        }
    }

    setPortfolios(portfolios) {
        this.props.setAlertsFilter("portfolios", portfolios);
        this.props.setAlertsFilter("offset", 0);
        this.getAlertList()
    }

    orderBy(orderBy, state) {
        if (this.props.alerts.filter.orderCol === orderBy){
            this.props.setAlertsFilter("orderDesc", !this.props.alerts.filter.orderDesc);
            this.setState(prevState => ({order: {...prevState.order, [state]: !this.props.alerts.filter.orderDesc }}));
        } else {
            this.props.setAlertsFilter("orderCol", orderBy);
            this.setState({ order: {...this.initialOrderState }});
            this.setState(prevState => ({order: {...prevState.order, [state]: false }}));
            if (this.props.alerts.filter.orderDesc)
                this.props.setAlertsFilter("orderDesc", false);
        }
        this.getAlertList()
    }

    selectAll() {
        var selected = [];
        if (this.state.selectAll === false) {
            this.state.portfolios.forEach(item => {
                if (item.alertsCount > 0) selected = selected.concat(item.id)
            });
        }
        this.setState({ selectAll: this.state.selectAll === false }, () => { this.setPortfolios(selected); });
    }

    isAllChecked = () => {
        if (this.props.alerts.filter.portfolios.length === 0) { return false };
        if (this.state.selectAll) { return true };
        return null;
    }

    onPageClick = (page) => {
        this.props.setAlertsFilter("offset", (page - 1) * this.props.alerts.filter.count);
        this.getAlertList()
    }

    setSeen = (id, alertId, seen) => {
        apiPost(`${window.babylonApiUrl}/api/portfolio/${id}/alerts/${alertId}/seen`, null, !seen,
            (s) => this.editSeen(id, alertId, s.data),
            (e) => {
                writeErr(e);
                this.onError();
            }
        );
    }

    editSeen(id, alertId, data) {
        if (!data.isSuccess) {
            this.onError({ exception: data.exception, exceptionData: data.exceptionData });
            return;
        }
        var index = this.state.portfolios.findIndex(p => p.id === id);
        var portfolios = this.state.portfolios;
        if (!isNullOrUndefined(portfolios) && index >= 0){
            if (data.value)
                portfolios[index].unreadCount--;
            else
                portfolios[index].unreadCount++;
            this.setState({portfolios: portfolios})
        }
        var alertIndex = this.props.alerts.data.alerts.findIndex(a => a.portfolioId === id && a.alertId === alertId);
        this.props.setSeen(alertIndex, data.value);
    }

    editNotes(id, alertId, data){
        var alertIndex = this.props.alerts.data.alerts.findIndex(a => a.portfolioId === id && a.alertId === alertId);
        this.props.editNotes(alertIndex, data.noteId);
    }

    selectAllSeen = (all) => {
        apiPost(
            `${getHostApi()}/api/portfolio/alerts/seen${all ? "/all" : ""}`, undefined,
            this.props.alerts.filter,
            (s) => {
                if (s.data.isSuccess) {
                    this.getAlertList();
                    this.getPortfolios();
                } else
                    this.props.setAlertsError({ exception: s.data.exception, exceptionData: s.data.exceptionData });
            },
            (e) => {
                writeErr(e);
                this.props.setAlertsError({ exception: "Common.Error" });
            }
        )
    }

    eventDescription = (a) => {
        const o = !isNullOrUndefined(a.old) && a.old !== "";
        const n = !isNullOrUndefined(a.new) && a.new !== "";
        const d = !isNullOrUndefined(a.description) && a.description !== "";
        return (
            <span>
                {o && <span className="alerts-description-old">{ReactHtmlParser(this.renderLink(a.old))}</span>}
                {(o && n) && <span> &rarr; </span>}
                {n && <span>{ReactHtmlParser(this.renderLink(a.new))}</span>}
                {d && <span>{(o || n) && " ("}{ReactHtmlParser(this.renderLink(a.description))}{(o || n) && ")"}</span>}
            </span>
        );
    }

    renderLink = (str) => {
        return str.replace("<a", "<a class=\'link-external" + (localStorage.locales_url_format === 'normal' ? ' is-normal\'' : '\''));
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.domain, user: state.userContext, alerts: state.alerts }),
    dispatch => bindActionCreators(({ ...domainActions, ...alertsActions, ...popupActions }), dispatch)
)(Alerts)));